import { postGoogleLogin } from '../../api/create';
import React, { useEffect, useState,useRef } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const GoogleAuth: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [, setError] = useState<string | null>(null);
  const [searchParams] = useSearchParams();
  const toastShown = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAuthDetails = async () => {
      const status = searchParams.get('status');
      const token = searchParams.get('token');

      if (status !== "true") {
        toast.error("We don't have your email in our system");
        setTimeout(() => { 
          navigate('/login');
        },5000)
        return;
      }
      

    try {
        setLoading(true);
        const response = await postGoogleLogin({ encode_token: token });
        const accessToken = response?.result?.token;
        const loggedUser = response?.result?.user;

        if (accessToken && loggedUser) {
          
            localStorage.setItem('accessToken', accessToken);
            localStorage.setItem('loggedUser', JSON.stringify(loggedUser));
            

            const isPatientLookupPresent = response?.result?.user?.access?.find((module:any) => module.module_name === 'Patient Lookup');
            if (isPatientLookupPresent){
              setTimeout(() => {
                window.location.href = "/patient-lookup";
              }, 5000);
            } else {
              setTimeout(() => {
                window.location.href = "/account-settings/profile-settings";
              }, 5000);
            }

            // Only show toast if it hasn't been shown yet
          if (!toastShown.current) {
            toast.success("Logged in Successfully");
            toastShown.current = true;  // Update the ref after showing the toast
          }
        }


    } catch (error) {
        console.error('Login failed:', error);
        setError('Login failed. Please try again.');
    }
    finally {
        setLoading(false);
    }
};


    fetchAuthDetails();
  }, [searchParams, navigate]);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <p>Loading...</p>
      </div>
    );
  }

  return null; // No UI, as the component handles redirects
};

export default GoogleAuth;
